import map from 'lodash/map'
import * as React from 'react'
import {useSafeEffectExtraDeps} from '@freckle/react-hooks'

import * as style from './panel-list-sorter.module.scss'

type Props = {
  radioLabels: Array<string>
  description?: string
  defaultIndex?: number
  sortBySorter: (a: number) => void
}

function PanelListFilters(props: Props): React.ReactElement {
  const {radioLabels, description, defaultIndex, sortBySorter} = props

  const initialCheckedIndex =
    defaultIndex !== undefined &&
    defaultIndex !== null &&
    defaultIndex < radioLabels.length &&
    defaultIndex > -1
      ? defaultIndex
      : -1

  const [checkedIndex, setCheckedIndex] = React.useState<number>(initialCheckedIndex)

  // Call sortBySorter when component mounts with valid defaultIndex
  useSafeEffectExtraDeps<{sortBySorter: (a: number) => void}>(
    ({sortBySorter}) => {
      if (initialCheckedIndex > -1) {
        sortBySorter(initialCheckedIndex)
      }
    },
    [initialCheckedIndex],
    {sortBySorter: {value: sortBySorter, comparator: () => true}}
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newCheckedIndex = parseInt(e.target.value, 10)
    sortBySorter(newCheckedIndex)
    setCheckedIndex(newCheckedIndex)
  }

  const radioInputs = map(radioLabels, (radioLabel, i: number) => (
    <label key={radioLabel} className={style.radioInline}>
      <input
        type="radio"
        name="panelListSort"
        value={i}
        checked={checkedIndex === i}
        onChange={onChange}
        className={style.radioInput}
      />
      {radioLabel}
    </label>
  ))

  return (
    <div className={style.panelListSorterContainer}>
      <fieldset className={style.panelListSorterElement}>
        {description && <legend className={style.panelListSorterLegend}>{description}</legend>}
        {radioInputs}
      </fieldset>
    </div>
  )
}

export default PanelListFilters
